import { useFormStore } from "../stores/FormStore";
import { mainAxios as axios } from "./axios";

//#region Forms
export const getForms = async () => {
  let response = await axios.get(`/forms`);

  if (response.data.state) {
    useFormStore
      .getState()
      .setForms(response.data.forms_list);
  }
  return response;
};

export const findForm = async (id) => {
  return axios.get(`/forms/${id}`);
};

export const createForm = async ({
  name,
  domain,
  html,
  contact_list_id,
}) => {
  return axios.post(`/forms`, {
    name,
    domain,
    html,
    contact_list_id,
  });
};

export const editForm = async ({
  id,
  name,
  domain,
  html,
  contact_list_id,
}) => {
  return axios.put(`/forms/${id}`, {
    name,
    domain,
    html,
    contact_list_id,
  });
};

export const deleteForm = async ({ id }) => {
  return axios.delete(`/forms/${id}`);
};

export const copyForm = async ({ id }) => {
  return axios.post(`/forms/${id}/copy`);
};
//#endregion
